import React from 'react';

import { IPMatching } from '../IPMatching/IPMatching';

export const IPMatchingPage: React.FC = () => <IPMatching />;
